module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAA8AgMAAADtUfddAAAACVBMVEUAK3/////OESbXH0AUAAAAH0lEQVR42mNgGAWMobhkmBhGigzLaBiMyozmhVEABQCzxQFQK1xvAwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/cr.png
// module id = Id2/
// module chunks = 0